import { apiClient } from './clienteHttp';

export interface ClienteCredencial {
  rfc: string;
  nombre_cliente: string;
  ultima_modificacion: string | null;
  /** Monedas que este cliente puede conciliar (ej. ["MXN","USD"]). Esta
   * plataforma se reutiliza entre distintos clientes contables y no todos
   * operan en las mismas monedas — null/undefined si no está configurado
   * (el llamador debe aplicar un fallback razonable). */
  monedas_soportadas?: string[] | null;
}

export interface ListCredencialesResponse {
  clientes: ClienteCredencial[];
  total: number;
}

export interface CredencialesPayload {
  rfc: string;
  nombre_cliente: string;
  certificado_base64: string;
  llave_base64: string;
  contrasena_base64: string;
  monedas_soportadas?: string[];
}

export interface CredencialesResponse {
  message: string;
  rfc: string;
  nombre_cliente: string;
  monedas_persistidas?: boolean;
}

export async function getCredenciales(): Promise<ListCredencialesResponse> {
  const res = await apiClient.get('/credenciales');
  return res.data;
}

export async function crearCredenciales(data: CredencialesPayload): Promise<CredencialesResponse> {
  const res = await apiClient.post('/credenciales', data);
  return res.data;
}

export async function actualizarCredenciales(
  rfc: string,
  data: CredencialesPayload,
): Promise<CredencialesResponse> {
  const res = await apiClient.put(`/credenciales/${rfc}`, data);
  return res.data;
}

export async function eliminarCredenciales(rfc: string): Promise<{ message: string; rfc: string }> {
  const res = await apiClient.delete(`/credenciales/${rfc}`);
  return res.data;
}
